import React, { useEffect, useState } from "react";
import { Col, Drawer } from "antd";
import CustomList from "../../../../components/List";
import ListItem from "../../../../components/ListItem";
import CustomPagination from "../../../../components/CustomPagination";
import { useEnvironmentalSocialSafeguards } from "../../../../../hooks/useDataHooks";
import { useReportDateRange } from "../../../../../hooks/useReportDateRange";
import useProcuringEntityPackage from "../../../../../hooks/useProcuringEntityPackage";
import ActionBar from "../../../../components/ActionBar";



const subProjectName = { xxl: 6, xl: 6, lg: 6, md: 6, sm: 12, xs: 12 };
const compliance_esmp = { xxl: 8, xl: 8, lg: 8, md: 8, sm: 12, xs: 12 };
const remarks = { xxl: 8, xl: 8, lg: 8, md: 8, sm: 12, xs: 12 };

const headerLayout = [
  { ...subProjectName, header: "Sub Project" },
  { ...compliance_esmp, header: "Compliant with ESMP" },
  { ...remarks, header: "Remarks" },
];

const EnvironmentalSafeguards = ({ match }) => {
  const {
    params: { packageId },
  } = match;
  const { startDate, endDate } = useReportDateRange();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  
  const { environmentalSafeguards, pagination, loading: environmentLoading, error } =
    useEnvironmentalSocialSafeguards(packageId, startDate, endDate, currentPage, pageSize);

  const [activeItem, setActiveItem] = useState(null);
  const [visible, setVisible] = useState(false);

  const { procuringEntityPackage } = useProcuringEntityPackage(packageId);
  const packageName = procuringEntityPackage?.name || "";
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleRowClick = (item) => {
    setActiveItem(item);
    setVisible(true);
  };

  const handleCloseDrawer = () => {
    setVisible(false);
  };

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
    setActiveItem(null);
  };

  return (
    <>
      <div>
        {error && (
          <div style={{ 
            margin: "16px 0", 
            padding: "16px", 
            backgroundColor: "#fff2f0", 
            border: "1px solid #ffccc7", 
            borderRadius: "6px",
            color: "#cf1322"
          }}>
            <strong>Error:</strong> Failed to load environmental safeguards data. Please try again later.
          </div>
        )}
              
        {!environmentLoading && !error && environmentalSafeguards.length === 0 && (
          <div style={{ 
            margin: "16px 0", 
            padding: "16px", 
            backgroundColor: "#f6ffed", 
            border: "1px solid #b7eb8f", 
            borderRadius: "6px",
            color: "#389e0d",
            textAlign: "center"
          }}>
            <strong>No Data Available:</strong> No environmental safeguards data found for the selected package and date range.
          </div>
        )}

        <ActionBar actionButtonProp={{  
          title: `${packageName || "==//=="}: Environmental and Social Safeguards`,
        }} />
        
        <div className="prst-table">
        <CustomList
          itemName="Environmental Safeguards"
          showToolbar={false}
          items={environmentalSafeguards}
          page={currentPage}
          itemCount={pagination?.total || 0}
          loading={environmentLoading}
          headerLayout={headerLayout}
          renderListItem={({ item }) => (
            <ListItem
              key={item.id} // eslint-disable-line
              name={item?.subProjectName || "==//=="}
              item={item}
              onClick={() => handleRowClick(item)}
              style={{
                backgroundColor:
                  activeItem?.id === item.id
                    ? "#f0f0f0"
                    : "transparent",
              }} // Highlight active row
            >
              <Col
                {...subProjectName}
                className="contentEllipse"
                data-label="Sub Project"
              >
                {item?.subProjectName?.length > 40 ? item?.subProjectName.slice(0, 40) + "..." : item?.subProjectName || "==//=="}
              </Col>

              <Col
                {...compliance_esmp}
                className="contentEllipse"
                data-label="Compliant with ESMP"
              >
                {item?.compliance_esmp?.length > 40 ? item?.compliance_esmp.slice(0, 40) + "..." : item?.compliance_esmp || "==//=="}
              </Col>

              <Col
                {...remarks}
                className="contentEllipse"
                data-label="Remarks"
              >
                {item?.remarks?.length > 40 ? item?.remarks.slice(0, 40) + "..." : item?.remarks || "==//=="}
              </Col>

              <button 
                className="view-card-details" 
                onClick={() => handleRowClick(item)}
              >
                View Details
              </button>
            </ListItem>
          )}
        />
        </div>
        
        <CustomPagination 
          pagination={pagination}
          onPageChange={handlePageChange}
          loading={environmentLoading}
        />

        {activeItem && (
          <Drawer
            title={`Environmental and Social Safeguards`}
            placement="right"
            closable={true}
            onClose={handleCloseDrawer}
            visible={visible}
            width={720}
          >
            <p
              style={{
                display: "flex",
                gap: "10px",
                textTransform: "capitalize",
              }}
            >
              <strong>Sub Project Name:</strong>{" "}
              {activeItem?.subProjectName || "==//=="}
            </p>
            <p
              style={{
                display: "flex",
                gap: "10px",
                textTransform: "capitalize",
              }}
            >
              <strong>Compliant with ESMP :</strong>{" "} 
              {activeItem?.esmp_compliance ? (
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {Object.keys(activeItem.esmp_compliance)
                    .filter((key) => activeItem.esmp_compliance[key])
                    .filter((item) => item.toLowerCase() !== "other")
                    .map((item) => (
                      <li
                        key={item}
                        style={{
                          display: "inline-block",
                          marginRight: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        <span
                          style={{
                            backgroundColor: "#f0f0f0",
                            padding: "5px 10px",
                            borderRadius: "10px",
                          }}
                        >
                          {item}
                        </span>
                      </li>
                    ))}
                </ul>
              ) : (
                "==//=="
              )}
            </p>
            <p
              style={{
                display: "flex",
                gap: "10px",
                textTransform: "capitalize",
              }}
            >
              <strong>Provide Remarks:</strong> {activeItem?.remarks || "==//=="}
            </p>
          </Drawer>
        )}
      </div>
    </>
  );
};

export default EnvironmentalSafeguards;
